var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "side-nav" },
    _vm._l(_vm.rootItems, function(root) {
      return _c(
        "div",
        { key: root.id, staticClass: "category" },
        [
          _c(
            "a",
            {
              attrs: { href: root.url },
              on: {
                click: function($event) {
                  return _vm.onClickLink([root.name])
                }
              }
            },
            [_vm._v("\n      " + _vm._s(root.name) + "\n    ")]
          ),
          _vm._l(
            (root.items || []).reduce(function(acc, items) {
              return acc.concat(items)
            }, []),
            function(item) {
              return _c(
                "ul",
                {
                  key: item.id,
                  class: [
                    "subcategory",
                    { active: item.url === _vm.activeCategory }
                  ]
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: item.url },
                      on: {
                        click: function($event) {
                          return _vm.onClickLink([root.name, item.name])
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
                  ),
                  _vm.activeCategory &&
                  _vm.activeCategory.includes(item.url) &&
                  item.items.length
                    ? _c(
                        "li",
                        _vm._l(
                          (item.items || []).reduce(function(acc, items) {
                            return acc.concat(items)
                          }, []),
                          function(sub) {
                            return _c(
                              "div",
                              {
                                key: sub.id,
                                class: {
                                  active: sub.url === _vm.activeCategory
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: sub.url },
                                    on: {
                                      click: function($event) {
                                        return _vm.onClickLink([
                                          root.name,
                                          item.name,
                                          sub.name
                                        ])
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(sub.name) +
                                        "\n          "
                                    )
                                  ]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e()
                ]
              )
            }
          )
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }